import { Editor } from "@tinymce/tinymce-react";
import { useRef } from "react";

import HNSColors from "../../HNSColors";

export function TextEditor({ value, onChangeHandler, initialHeight }) {
  const editorRef = useRef(null);

  return (
    <>
      <Editor
        tinymceScriptSrc="/tinymce/js/tinymce/tinymce.min.js"
        textareaName="content"
        licenseKey="gpl"
        value={value}
        onEditorChange={(newText) => onChangeHandler(newText)}
        onInit={(_evt, editor) => (editorRef.current = editor)}
        init={{
          ...(initialHeight ? { height: initialHeight } : {}),
          resize: true,
          menubar: false,
          branding: false,
          browser_spellcheck: true,
          contextmenu: false,
          plugins: ["lists"],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",

          setup: (editor) => {
            editor.on("SkinLoaded", () => {
              const css = `
                /* toolbar background */
                .tox-editor-header,
                .tox .tox-toolbar-overlord,
                div.tox-toolbar__primary,
                .tox-toolbar__group {
                  background-color: ${HNSColors.tertiary[950]} !important;
                }

                /* toolbar buttons */
                .tox-toolbar__group button,
                .tox .tox-tbtn {
                  background: none !important;
                  color: ${HNSColors.primary[500]} !important;
                }

                /* disabled, hover, active states */
                .tox .tox-tbtn--disabled,
                .tox .tox-tbtn:hover,
                .tox .tox-tbtn--enabled,
                .tox .tox-tbtn--active {
                  background: none !important;
                }

                /* toolbar icons */
                .tox .tox-tbtn svg,
                .tox .tox-icon svg,
                .tox-icon-highlight-bg-color__color {
                  fill: ${HNSColors.primary[500]} !important;
                }
              `;
              const styleTag = document.createElement("style");
              styleTag.innerHTML = css;
              document.head.appendChild(styleTag);
            });
          },
        }}
      />
    </>
  );
}
